import { createFileRoute } from '@tanstack/react-router'
import { TransactionsScreen } from '@/features/transactions/TransactionsScreen'

export const Route = createFileRoute('/transactions')({
  validateSearch: (search: Record<string, unknown>): { txn?: string } => ({
    txn: typeof search.txn === 'string' ? search.txn : undefined,
  }),
  component: TransactionsPage,
})

function TransactionsPage() {
  const { txn } = Route.useSearch()
  return <TransactionsScreen focusTxnId={txn ?? null} />
}
